<template>
  <div class="activitycenter-page">
    <header-cmp></header-cmp>

    <section class="page-part banner banner_activity">
      <h1 class="banner-title">玩转世界杯&nbsp;&nbsp;周周抽大奖</h1>
      <p class="banner-detail">
        活动时间：2018年6月14日-2018年7月11日
        <br> 参与用户：所有通过我司APP自主下单的客户
        <br> 参与方式：打开享运货主APP点击活动页即可参与
        <br>
      </p>
    </section>

    <section class="page-part content" id="activity">
      <div class="page-inner">
        <h1 class="page-title">活动内容</h1>
        <div class="content-container">
          <section>
            <h3 class="content-title">A 活动规则</h3>
            <span>1、参与条件：为答谢客户，在世界杯期间（6.14-7.15），凡通过我司APP自主下单的客户，即可参加抽奖活动。（自主通过APP下单发货，通过电话，微信，QQ等渠道下单的客户不能参加）
2、抽奖时间和抽奖对象：
（1）、6月21日（6.14 0:00-6.20 24点期间下单客户）；
（2）、6月28日（6.21 0:00-6.27 24点期间下单客户）；
（3）、7月05日（6.28 0:00-7.4  24点期间下单客户）；
（4）、7月12日（7.5 0:00-7.11  24点期间下单客户）；
3、每个账户在每个抽奖时间内只能参与一次；
            </span>
          </section>

          <section>
            <h3 class="content-title">B 领奖方式</h3>
            <span>1、满足条件的货主用户在以上抽奖时间点打开享运货主APP抽奖；
2、中奖客户填写领奖信息：姓名，电话，快递地址；奖品在5个工作日内快递到货；
3、奖项设置：每个抽奖日抽取一二三四等奖各1个，参与奖8个。
一等奖（小米电饭煲一台）；二等奖（小米热水壶一台）；三等奖（小米汤锅一个）；四等奖（手环一只）；参与奖（湿普乐高级湿巾大礼包一份）。
            </span>
          </section>

        </div>
        <div class="pic-container"></div>
        <section style="overflow:hidden;">
          <h3 class="content-title">C 活动奖品</h3>
          <div class="content-pics">
            <div class="pic-detail">
              <img src="../assets/images/page_activitycenter/prize1.png" alt="小米电饭煲">
              <h3>一等奖</h3>
              <p>小米电饭煲一台</p>
            </div>
            <div class="pic-detail">
              <img src="../assets/images/page_activitycenter/prize2.png" alt="小米热水壶">
              <h3>二等奖</h3>
              <p>小米热水壶一台</p>
            </div>
            <div class="pic-detail">
              <img src="../assets/images/page_activitycenter/prize3.png" alt="小米汤锅">
              <h3>三等奖</h3>
              <p>小米汤锅一个</p>
            </div>
            <div class="pic-detail">
              <img src="../assets/images/page_activitycenter/prize4.png" alt="智能手环">
              <h3>四等奖</h3>
              <p>智能手环一个</p>
            </div>
          </div>
        </section>
      </div>

    </section>

    <footer-cmp></footer-cmp>
  </div>
</template>

<script type="text/ecmascript-6">
  import HeaderCmp from '@/components/header';
  import FooterCmp from '@/components/footer';

  export default {
    name: 'activitycenterPage',
    data() {
      return {

      }
    },
    components: {
      HeaderCmp,
      FooterCmp
    },
    mounted() {
      this.$utils.watchRouteGoAnchor(this);
    },
    // watch: {
    //   '$route' () {
    //     this.$utils.watchRouteGoAnchor(this);
    //   }
    // }
  }

</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../style/_variable";
  .activitycenter-page {
    width: 100%;

    .banner {
      height: 500px;
      text-align: center;
      padding: 184px 0 180px 0;
      &_activity {
        background: url("../assets/images/page_activitycenter/banner3.png") center no-repeat;
        background-size:100% 100%;
        -moz-background-size:100% 100%;
        // background: url("../assets/images/page_activitycenter/231672728746870282.png") center no-repeat;
      }
      &-title {
        font-size: 64px;
        color: white;
        font-weight: bold;
      }
      &-detail {
        width: 480px;
        display: inline-block;
        text-align: left;
        color: white;
        border: 1px solid white;
        padding: 20px 40px;
        line-height: 2;
        margin-top: 80px;
      }
    }

    .content {
      padding: 72px 0 87px 0;
      .page-title {
        font-size: 36px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 60px;
      }
      .content-container {
        display: inline-block;
        width: 530px;
        margin-right: 50px;
        vertical-align: top;

      }
      .content-title {
          font-size: 18px;
          color: $text-clr_primary;
          margin-bottom: 12px;
        }
        section {
          margin-bottom: 54px;
          span {
            line-height: 3;
            color: $text-clr_light;
          }
        }
      .pic-container {
        display: inline-block;
        width: 514px;
        height: 514px;
        background: url('../assets/images/page_activitycenter/activity.png');
      }
      .pic-detail {
        float: left;
        width: 255px;
        margin-right: 26px;
        img {
          border: 1px solid $boder-clr_dark;
          margin-bottom: 30px;
        }
        h3 {
          font-size: 18px;
          color: $text-clr_primary;
          text-align: center;
          margin-bottom: 10px;
        }
        p {
          text-align: center;
        }

        &:last-child {
            margin-right: 0;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/activitycenter.vue